module.exports = __webpack_public_path__ + "assets/certificate_pdf/MTA Software Testing Fundamental_98-379_E804-25788298419.7167e9ac.pdf";